import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { GithubCardBox } from './GithubCard.style';

const GithubCard = ({ githubRepo }) => {
  // Check if the githubRepo string starts with a gist prefix
  const isGist = githubRepo.startsWith('https://gist.github.com/');

  // Determine the URL to use based on whether a Gist URL is detected
  const urlToUse = isGist ? githubRepo : 'https://github.com/' + githubRepo;

  return (
    <GithubCardBox>
      <div style={{ margin: 20, paddingBottom: 15, paddingTop: 1 }}>
        <h4>Get the code for this post!</h4>
        <a
          aria-label={isGist ? "view gist" : "view on github"}
          rel="noopener noreferrer"
          target="__blank"
          href={urlToUse}
        >
          <FontAwesomeIcon style={{ fontSize: 24, marginRight: 5 }} icon={['fab', 'github']} />
        </a>
        {isGist ? (
          <a
            aria-label="view gist"
            rel="noopener noreferrer"
            target="__blank"
            href={urlToUse}
          >
            View Gist
          </a>
        ) : (
          <a
            aria-label="view on github"
            rel="noopener noreferrer"
            target="__blank"
            href={urlToUse}
          >
            {githubRepo}
          </a>
        )}
      </div>
    </GithubCardBox>
  );
};

export default GithubCard;
